import React from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import conta2 from "../../../assets/images/landing/areas - team/contador2.jpg";
import rrhh1 from "../../../assets/images/landing/areas - team/rrhh1.jpg";
import adm1 from "../../../assets/images/landing/areas - team/adm1.jpg";

import "./scss/areateam.scss";

const AreaTeam = () => {
  return (
    <section className="section bg-gradient-aesthetic" id="areateam">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8}>
            <div className="text-center mb-5 mt-1">
              <h2 className="main-title text-white fw-bold">Team Work</h2>
              <h4 className="sub-title text-white fw-semibold">Areas</h4>
            </div>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <AreaCard
            img={conta2}
            title={["Contabilidad", "Finanzas", "Tributario"]}
            desc="Registro, proceso, análisis y reporte de todas las transacciones de la empresa, tanto financiera como tributaria."
          />
          <AreaCard
            img={rrhh1}
            title={["Recursos Humanos", "Bienestar"]}
            desc="Selección, gestión, formación y desarrollo profesional del personal en la empresa."
          />
          <AreaCard
            img={adm1}
            title={["Management", "Administración", "Gerenciamiento"]}
            desc="Gestión, revisión y dirección de nuestros clientes en base a los procesos administrativos de su empresa."
          />
        </Row>
      </Container>
    </section>
  );
};

const AreaCard = ({ img, title, desc }) => (
  <Col lg={4} md={6} className="mb-4">
    <Card className="card-aesthetic text-center h-100">
      <CardBody className="p-4 d-flex flex-column align-items-center">
        <div className="title-box w-100 mb-3 p-2 rounded">
          {title.map((line, idx) => (
            <h5 key={idx} className="fw-semibold text-white m-0">
              {line}
            </h5>
          ))}
        </div>
        <div className="area-image mb-3">
          <img
            src={img}
            alt={title[0]}
            className="img-fluid rounded"
          />
        </div>
        <p className="text-justified text-muted ff-secondary">{desc}</p>
      </CardBody>
    </Card>
  </Col>
);

export default AreaTeam;
